var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('div',{staticClass:"page--title"},[_vm._v("ABILITYDEX")]),_c('show-cards',{attrs:{"inputs":this.$store.getters.allAbilities,"job":"Ability","showA":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }